import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DatatablePagerComponent } from './datatable-pager/datatable-pager.component';
import { DatatableFooterComponent } from './datatable-footer/datatable-footer.component';
import { DatatableActionsComponent } from './datatable-actions/datatable-actions.component';
import { QueryToolbarComponent } from './query-toolbar/query-toolbar.component';
import { ZrButtonComponent } from './zr-button/zr-button.component';
import { ZrTabsComponent } from './zr-tabs/zr-tabs.component';
import { ZrDropdownSelectionComponent } from './zr-dropdown-selection/zr-dropdown-selection.component';
import { ZrProgressComponent } from './zr-progress/zr-progress.component';
import { ZrSelectSelectionComponent } from './zr-select-selection/zr-select-selection.component';
import { ZrValidationMessageComponent } from './zr-validation-message/zr-validation-message.component';
import { ZrSwitchComponent } from './zr-switch/zr-switch.component';

@NgModule({
  declarations: [
    DatatablePagerComponent,
    DatatableFooterComponent,
    DatatableActionsComponent,
    QueryToolbarComponent,
    ZrButtonComponent,
    ZrTabsComponent,
    ZrDropdownSelectionComponent,
    ZrProgressComponent,
    ZrSelectSelectionComponent,
    ZrValidationMessageComponent,
    ZrSwitchComponent

  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    DatatablePagerComponent,
    DatatableFooterComponent,
    DatatableActionsComponent,
    QueryToolbarComponent,
    ZrButtonComponent,
    ZrTabsComponent,
    ZrDropdownSelectionComponent,
    ZrProgressComponent,
    ZrSelectSelectionComponent,
    ZrValidationMessageComponent,
    ZrSwitchComponent
  ]
})
export class ZrAngularModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ZrAngularModule
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/zr-angular.module.ts